export default __webpack_public_path__ + "92dfd46233dd9f0c966b8c9141c592aa.svg";